<div class="panel-content flex flex-col gap-2 mx-1">
    <div class="flex flex-col px-4 py-6 bg-on-primary rounded-xl">
        <div class="flex items-center gap-2 mb-4">
            <app-main-title
                iconColor="text-custom-blue"
                iconSize="xl"
                titleSize="text-2xl font-medium"
                [icon]="['fas', ActionsEnum.SETTINGS]"
                [title]="'settings' | transloco" />

            <app-icon-button
                class="text-custom-dark-grey pt-1"
                iconSize="lg"
                [icon]="['fas', 'ellipsis-vertical']"
                [matMenuTriggerFor]="menu" />
            <mat-menu #menu="matMenu">
                <button
                    mat-menu-item
                    [disabled]="!hasEditPermissions()"
                    [matTooltip]="'insufficientPermissions' | transloco"
                    [matTooltipDisabled]="hasEditPermissions()"
                    (click)="openEditProjectModal()">
                    {{ 'edit' | transloco }}
                </button>

                <button
                    class="!text-error"
                    mat-menu-item
                    [disabled]="!canDeleteProject()"
                    [matTooltip]="'insufficientPermissions' | transloco"
                    [matTooltipDisabled]="canDeleteProject()"
                    (click)="openDeleteProjectModal()">
                    {{ 'delete' | transloco }}
                </button>
            </mat-menu>
        </div>

        <span class="flex flex-row items-center">
            <fa-icon
                class="px-4"
                size="xl"
                [icon]="['fas', 'circle-small']"
                [style.color]="projectBloc.value()!.color" />
            <p class="!m-0 text-base">{{ projectBloc.value()!.name }}</p>
        </span>
        @if (projectBloc.value()!.description) {
            <p class="pt-4 px-4 text-base">{{ projectBloc.value()!.description }}</p>
        }
    </div>

    <div class="rounded-t-lg rounded-b-sm flex-1 flex flex-col min-h-0">
        <app-tab
            class="h-full flex flex-col"
            [defaultTabIndex]="defaultTabIndex()"
            [tabs]="tabs">
            <ng-template appTabContent>
                <app-project-access-settings class="overflow-y-auto pr-0" />
            </ng-template>
            <ng-template appTabContent>
                <app-project-layers-settings class="flex flex-col gap-5 min-h-0" />
            </ng-template>
            <ng-template appTabContent>
                <app-project-deposits-settings class="overflow-y-auto pr-0" />
            </ng-template>
        </app-tab>
    </div>
</div>
